import { graphql, Query } from 'overmind-graphql'
import { queries, mutations } from 'src/state/gql/_operations'
import logger from 'src/utils/logger'
import { SubscriptionClient } from 'subscriptions-transport-ws'
import { AppState, GraphQLError, GraphQLSubscriptionResultsPayload, SubscriptionInitParams, Subscriptions } from 'src/state/_types'

export const gql = graphql({
    queries,
    mutations
})

export const subscriptions = (() => {

    let client: SubscriptionClient
    let subscriptions: Subscriptions = {}
    let auth: { [index: string]: any } = {
        auhthorized: false,
        session_id: null,
        user_id: null,
        user_role: null,
        token: null
    }

    return {
        initialize(params: SubscriptionInitParams) {
            logger('Initializing GraphQL Subscriptions Layer')
            auth = { ...params.auth }

            let newClient = new SubscriptionClient(import.meta.env.VITE_GQL_API_WS_URL || '', {
                reconnect: true,
                connectionParams: {
                    headers: {
                        'Authorization': `Bearer ${auth.token}`
                    }
                }
            })

            newClient.onConnected(() => {
                logger('Connected to the WebSocket')
            })

            newClient.onDisconnected((e,context) => {
                logger('Disconnected from the WebSocket',{e,context},'warn')
            })

            newClient.onReconnecting(() => {
                logger('Reconnecting to the WebSocket', undefined, 'warn')
            })

            newClient.onReconnected(() => {
                logger('Reconnected to the WebSocket')
            })

            newClient.onError((error) => {
                logger('WebSocket error:', error, 'error')
            })

            client = newClient

        },
        updateClientAuth(newAuth: AppState['auth']) {
            let authUpdates: { [index: string]: any } = { ...newAuth }
            let updatedAuth = Object.keys(newAuth).reduce((updates, authKey) => {
                let newSetting = authUpdates[authKey]
                return auth[authKey] === newSetting ? updates : { ...updates, [authKey]: newSetting }
            }, {})
            if (Object.keys(updatedAuth).length) {
                auth = { ...auth, ...updatedAuth }
                this.updateClient()
            }
        },
        updateClient() {
            logger('Updating GraphQL Subscriptions Layer Auth')
            if (client) client.close()
            client = new SubscriptionClient(import.meta.env.VITE_GQL_API_WS_URL || '', {
                reconnect: true,
                connectionParams: {
                    headers: {
                        'Authorization': `Bearer ${auth.token}`
                    }
                }
            })
        },
        subscribe<P extends any, V extends Object>(subscriptionKey: string, query: Query<P, V>, variables: V, handler: (payload: GraphQLSubscriptionResultsPayload<P>) => void, callback?: () => void) {
            if (client) {
                if (subscriptions[subscriptionKey]) {
                    subscriptions[subscriptionKey].unsubscribe()
                }
                let observable = client.request({ query: query as any, variables })
                subscriptions[subscriptionKey] = observable.subscribe({
                    next: ({ data }) => handler({ error: null, data: data as P }),
                    error: (error) => handler({ error: error as unknown as GraphQLError, data: null })
                })
            } else {
                logger('GraphQL Subscriptions Layer Not Initialized', {}, 'error')
            }
            if (callback) return callback()
        },
        unsubscribe(subscriptionKey: string) {
            if (subscriptions.hasOwnProperty(subscriptionKey)) {
                subscriptions[subscriptionKey].unsubscribe()
                delete subscriptions[subscriptionKey]
            }
        }
    }

})()    